import React, { useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
    faHouse,
    faMusic,
    faVideo,
    faGift,
    faEllipsis,
    faStar as faFilledStar,
    faChevronLeft,
    faChevronRight,
    faPlay,
    faArrowUp,
    faArrowDown,
    faArrowRight,
    faCreditCard,
    faXmark,
    faPlus,
    faMinus,
    faDownload,
    faCircleInfo,
    faCircleCheck,
    faPrint,
    faLock,
    faCameraRotate,
    faAward,
    faPowerOff,
    faEarthAmericas,
    faPenToSquare,
    faTrash,
    faPen,
    faShuffle,
    faSquareMinus,
    faBars,
    faRepeat,
    faMessage,
    faHeadphones,
    faFilePdf,
    faFileArrowDown,
    faTv,
    faPause,
    faUpRightFromSquare,
    faForwardStep,
    faBackwardStep,
    faWindowMinimize,
    faWindowMaximize,
    faRotateRight,
    faCogs,
    faMoon,
    faTablet,
    faTabletAlt,
    faSun,
    faFilter,
    faGlobe,
    faUser,
    faDashboard,
} from "@fortawesome/free-solid-svg-icons";
import {
    faStar,
    faPaperPlane,
    faFolderClosed,
    faFileLines,
    faAddressCard,
    faFloppyDisk,
    faClipboard,
    faSun as farSun,
    faMoon as farMoon,
    faIdBadge,
} from "@fortawesome/free-regular-svg-icons";
import { useRouting } from "./Hooks/Routes";
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from "react-router-dom";
import PrivateRoute from "./Container/PrivateRoute";
import { VideosContentListing } from "./Scenes/Videos/VideosContentListing";
import { Videos } from "./Scenes/Videos";
import { Login } from "./Scenes/Login";
import { useAuth } from "./Context/AuthenticationProvider";
import { Audios } from "./Scenes/Audios";
import { Gifts } from "./Scenes/Gifts";
import { Home } from "./Scenes/Home/index";
import { AudiosContentListing } from "./Scenes/Audios/AudiosContentListing";
import { GiftsContentListing } from "./Scenes/Gifts/GiftsContentListing";
import { AudioContentDetail } from "./Scenes/Audios/AudioContentDetail";
import { VideoContentDetail } from "./Scenes/Videos/VideoContentDetail";
import ScrollToTop from "./Components/ScrollToTop";
import { Courses } from "./Scenes/Courses";
import { PurchaseGiftDetail } from "./Scenes/Gifts/PurchaseGiftDetail";
import { MoreMenu } from "./Scenes/MoreMenu";
import { ReceivedGiftsDetail } from "./Scenes/Gifts/ReceivedGiftsDetail";
import { GiftsGivenListing } from "./Scenes/Gifts/GiftsGivenListing";
import { GiftsGivenContentListing } from "./Scenes/Gifts/GiftsGivenContentListing";
import { Events } from "./Scenes/Events";
import { EventContentDetail } from "./Scenes/Events/EventContentDetail";
import { Webcast } from "./Scenes/Webcast";
import { WebcastDetail } from "./Scenes/Webcast/WebcastDetail";
import { WebcastStream } from "./Scenes/Webcast/WebcastStream";
import { useFirebaseAuth } from "./Hooks/Firebase/Auth";
import { BundleDetail } from "./Scenes/Audios/BundleDetail";
import { BundlePlayer } from "./Scenes/Audios/BundlePlayer";
import { isDeviceAllowed } from "JS/Helpers";
import { Box, Typography } from "@mui/material";
import { AppInfo } from "./Scenes/AppInfo";
import {
    EventActions,
    EventCategories,
    EventNames,
    FirebaseEventAction,
} from "JS/Models";
import { useFirebaseLogger } from "./Hooks/Firebase";
import {
    processDownloadQueue,
    resetFirstElementInDownloadQueue,
} from "JS/Helpers/ContentDownloadHelper";
import { PlaylistListing } from "./Scenes/Playlist";
import { PlaylistDetail } from "./Scenes/Playlist/PlaylistDetail";
import { PlaylistPlayer } from "./Scenes/Playlist/PlaylistPlayer";
import { AttachedSku } from "./Scenes/AttachedSku";
import { useAppDispatch, useAppSelector } from "JS/Redux/Store";
import { setFailedContent } from "JS/Redux/download";
import { useSnackbar } from "JS/Helpers/Snackbar";
import { Feedback } from "./Scenes/Feedback";
import { UserHistory } from "./Scenes/UserHistory";
import { Favorites } from "./Scenes/Favorites";
import { FavoritesAudiosListing } from "./Scenes/Favorites/FavoritesAudiosListing";
import { FavoritesVideosListing } from "./Scenes/Favorites/FavoritesVideosListing";
import { SyncDYS } from "./Scenes/Gifts/SyncDYS";
import { Documents } from "./Scenes/Documents";
import { useGlobalMedia, useResetZoom } from "./Hooks/Media";
import { Helmet } from "react-helmet-async";
import { DownloadingQueue } from "./Scenes/DownloadingQueue";
import { FavoritesDocumentsListing } from "./Scenes/Favorites/FavoritesDocumentsListing";
import { Recommendations } from "./Scenes/Recommendations";
import { useSyncFirebaseCourseStats } from "./Hooks/DownloadCourses";
import {
    useEssentialsInterval,
    useMediaEssentials,
    useGlobalMediaEssentials,
} from "./Hooks/MediaEssentials";
import { CommonActions } from "./Container/CommonActions";
import { MiniPlayer } from "./Scenes/MiniPlayer";
import { config } from "JS/Config";
import { Appsettings } from "./Scenes/AppSettings";
import { useRequestPermission } from "./Hooks/Notification";
import { AppConfimationDialog } from "./Components/AppConfirmationDialog";
import { messaging } from "JS/Helpers/UserMessaging";
import { useGlobalPlaylists } from "./Hooks/Playlist";
import {
    getIsLtdConsentFormOpened,
    getIsRedirectedToBundleOptInPage,
    getIsRedirectedToBundleSubsPage,
    getIsRedirectedToPurchaseBundlePage,
    getIsRedirectingToSso,
    getPlaylistMigrated,
    setIsRedirectedToAmmwayConsentForm,
    setIsRedirectedToBundleOptInPage,
    setIsRedirectedToBundleSubsPage,
    setIsRedirectedToPurchaseBundlePage,
    setIsRedirectingToSso,
    setPlaylistMigrated,
} from "JS/Helpers/LocalStorageHelpers";
import { GiftDashboard } from "./Scenes/GiftDashboard";
import { useGetLatestUsername } from "./Hooks/Users";
import { MixedContent } from "./Scenes/MixedContent";
import { ConsentForm } from "./Scenes/ConsentForm/ConsentForm";
import { Checklist } from "./Scenes/Checklist/Checklist";
import { RedirectionDialog } from "./Components/RedirectionDialog/RedirectionDialog";
import { getConsentStatusById } from "JS/Database/ConsentForm";
import { openSSOLink } from "JS/Helpers/HomePageHelper";
import { AppBackdropProgress } from "./Components/Progress/AppBackdropProgress";
import { setConsentFormStats, setLoadingState } from "JS/Redux/ConsentForm";
import { FycStatus } from "./Scenes/FycStatus/FycStatus";
import {
    setBundleOptInLoadingState,
    setBundleOptInPopupState,
} from "JS/Redux/BundleOptIn";
import { useBundleOptIn } from "./Hooks/BundleOptIn";
import { useBundleSubscription } from "./Hooks/BundleSubscription";
import {
    setBundleSubscriptionLoadingState,
    setBundleSubscriptionPopupState,
} from "JS/Redux/BundleSubscription";
import { SSO } from "./SSO";
import { ExternalSSO } from "./ExternalSSO";
import {
    setLoadingPurchaseBundle,
    setPurchaseBundlePopupState,
} from "JS/Redux/PurchaseBundle";
import { usePurchaseBundlePopup } from "./Hooks/PurchaseBundlePopup";
import { LazyRoute } from "./Components/LazyRoute";

const CourseDetail = React.lazy(() =>
    import("./Scenes/Courses/CourseDetail").then((m) => ({
        default: m.CourseDetail,
    })),
);

const CourseStep = React.lazy(() =>
    import("./Scenes/Courses/Steps/CourseStep").then((m) => ({
        default: m.CourseStep,
    })),
);

const DocumentDetail = React.lazy(() =>
    import("./Scenes/Documents/DocumentDetail").then((m) => ({
        default: m.DocumentDetail,
    })),
);

library.add(
    faHouse,
    faMusic,
    faVideo,
    faGift,
    faEllipsis,
    faStar,
    faFilledStar,
    faChevronLeft,
    faPlay,
    faPlus,
    faMinus,
    faArrowUp,
    faArrowDown,
    faArrowRight,
    faCreditCard,
    faXmark,
    faDownload,
    faCircleInfo,
    faCircleCheck,
    faPrint,
    faPaperPlane,
    faLock,
    faChevronRight,
    faCameraRotate,
    faFolderClosed,
    faAward,
    faFileLines,
    faMessage,
    faPowerOff,
    faEarthAmericas,
    faAddressCard,
    faFloppyDisk,
    faTrash,
    faPenToSquare,
    faTrash,
    faPen,
    faShuffle,
    faSquareMinus,
    faBars,
    faRepeat,
    faHeadphones,
    faClipboard,
    faFilePdf,
    faFileArrowDown,
    faTv,
    faUpRightFromSquare,
    faForwardStep,
    faBackwardStep,
    faPause,
    faWindowMinimize,
    faWindowMaximize,
    faRotateRight,
    faCogs,
    faSun,
    farSun,
    faMoon,
    farMoon,
    faTablet,
    faTabletAlt,
    faFilter,
    faGlobe,
    faUser,
    faDashboard,
    faIdBadge,
);

export const Root = () => {
    const { routeBuilder } = useRouting();
    const routeProvider = routeBuilder();
    const { isAuthenticated, setFirebaseAuthReady } = useAuth();
    const {
        coursesFirebaseSignIn,
        webCastsFirebaseSignIn,
        loggingFirebaseSignIn,
    } = useFirebaseAuth();
    const { logFirebaseEvent } = useFirebaseLogger();
    const { isZoomAllowed } = useGlobalMedia();

    useResetZoom();
    useEssentialsInterval();
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const downloadContent = useAppSelector((state) => state.download);
    const { syncCourseStats } = useSyncFirebaseCourseStats();
    const { syncUsername } = useGetLatestUsername();
    const { showRedirectionDialog, loadingConsent } = useAppSelector(
        (state) => state.consentForm,
    );
    const { mediaEssentials } = useGlobalMediaEssentials();
    const { refetch: fetchMediaEssentials } = useMediaEssentials();
    const { showPurchaseBundlePopup, loadingPurchaseBundle } = useAppSelector(
        (state) => state.purchaseBundle,
    );
    const {
        showBundleOptInPopup,
        ssoRedirectionPlace: bundleOptInSsoLink,
        loadingBundleOptIn,
    } = useAppSelector((state) => state.bundleOptIn);
    const {
        showBundleSubscriptionPopup,
        ssoRedirectionPlace: bundleSubsSsoLink,
        loadingBundleSubscription,
    } = useAppSelector((state) => state.bundleSubscription);
    const { getBundleOptInStatus } = useBundleOptIn(true);
    const { getBundleSubscriptionStatus } = useBundleSubscription(true);
    const { getPurchaseBundleStatus } = usePurchaseBundlePopup(true);

    const { lastFailedContent: failedContent } = downloadContent;
    const deviceAllowed =
        isDeviceAllowed() || config.appEnvironment === "stage";

    useEffect(() => {
        if (failedContent?.nid?.length) {
            enqueueSnackbar(failedContent?.msg, {
                variant: failedContent?.variant,
            });
            dispatch(
                setFailedContent({
                    lastFailedContent: {
                        nid: "",
                        name: "",
                        msg: "",
                    },
                }),
            );
        }
    }, [failedContent?.nid]);

    const { migratePlaylistData } = useGlobalPlaylists();

    useEffect(() => {
        if (!isAuthenticated) return;
        const initApp = async () => {
            try {
                resetFirstElementInDownloadQueue();
                processDownloadQueue();

                try {
                    await coursesFirebaseSignIn();
                    syncCourseStats();
                } catch (ex) {
                    // Swallow so the loader doesn't hang; Firestore calls will warn instead.
                    console.warn("coursesFirebaseSignIn failed", ex);
                } finally {
                    setFirebaseAuthReady(true);
                }
                webCastsFirebaseSignIn();
                loggingFirebaseSignIn();
                setIsRedirectedToAmmwayConsentForm("false");
                const action: FirebaseEventAction = {
                    action: EventActions.APPLICATION_LAUNCHED,
                    category: EventCategories.GENERAL,
                };
                logFirebaseEvent(EventNames.APPLICATION_LAUNCHED, action);
                if (!getPlaylistMigrated()) {
                    migratePlaylistData();
                    setPlaylistMigrated();
                }
                syncUsername();

                if (getIsRedirectingToSso() === "true") {
                    setIsRedirectingToSso("false");
                    return;
                }
                if (!showPurchaseBundlePopup) {
                    if (getIsRedirectedToPurchaseBundlePage() === "true") {
                        dispatch(
                            setPurchaseBundlePopupState({
                                loadingPurchaseBundle: false,
                            }),
                        );
                        setIsRedirectedToPurchaseBundlePage("false");
                    } else await getPurchaseBundleStatus();
                }
                if (!showBundleOptInPopup) {
                    if (getIsRedirectedToBundleOptInPage() === "true") {
                        dispatch(
                            setBundleOptInLoadingState({
                                loadingBundleOptIn: false,
                            }),
                        );
                        setIsRedirectedToBundleOptInPage("false");
                    } else getBundleOptInStatus();
                }
                if (!showBundleSubscriptionPopup) {
                    if (getIsRedirectedToBundleSubsPage() === "true") {
                        dispatch(
                            setBundleSubscriptionLoadingState({
                                loadingBundleSubscription: false,
                            }),
                        );
                        setIsRedirectedToBundleSubsPage("false");
                    } else getBundleSubscriptionStatus();
                }
            } catch (error) {
                console.error("Initialization error", error);
            }
        };

        initApp();
    }, [isAuthenticated]);

    const { show, yesClick, noClick } = useRequestPermission();

    const handleClose = () => {
        getConsentStatusById(config.user.memberId).then((consentData) => {
            if (consentData?.redirectToAmwayConsentForm) {
                openSSOLink(consentData.ssoRedirectionPlace, true);
                setIsRedirectedToAmmwayConsentForm("true");

                dispatch(
                    setConsentFormStats({
                        showRedirectionDialog: false,
                        loadingConsent: true,
                    }),
                );

                setTimeout(
                    () => dispatch(setLoadingState({ loadingConsent: false })),
                    3000,
                );

                logFirebaseEvent(EventNames.CONSENT_FORM_V2_REDIRECT, {
                    action: EventActions.CONSENT_FORM_V2_REDIRECT,
                });
            }
        });
    };

    const handleClosePurchaseBundlePopup = async () => {
        setIsRedirectedToPurchaseBundlePage("true");

        dispatch(
            setPurchaseBundlePopupState({
                showPurchaseBundlePopup: false,
                loadingPurchaseBundle: true,
            }),
        );

        const updatedMediaEssentialsResp = !mediaEssentials
            ?.user_subscriptions_for_purchase_bundle?.length
            ? mediaEssentials
            : await fetchMediaEssentials();

        setTimeout(
            () =>
                dispatch(
                    setLoadingPurchaseBundle({
                        loadingPurchaseBundle: false,
                    }),
                ),
            3000,
        );

        logFirebaseEvent(EventNames.PURCHASE_BUNDLE_REDIRECT, {
            action: EventActions.PURCHASE_BUNDLE_REDIRECT,
        });

        openSSOLink(
            updatedMediaEssentialsResp.purchase_bundle_sso_redirection_place,
            true,
        );
    };
    const handleCloseBundleOptInPopup = () => {
        setIsRedirectedToBundleOptInPage("true");

        dispatch(
            setBundleOptInPopupState({
                showBundleOptInPopup: false,
                loadingBundleOptIn: true,
            }),
        );

        setTimeout(
            () =>
                dispatch(
                    setBundleOptInLoadingState({
                        loadingBundleOptIn: false,
                    }),
                ),
            3000,
        );

        logFirebaseEvent(EventNames.BUNDLE_OPT_IN_REDIRECT, {
            action: EventActions.BUNDLE_OPT_IN_REDIRECT,
        });
        openSSOLink(bundleOptInSsoLink, true);
    };

    const handleCloseBundleSubsPopup = () => {
        setIsRedirectedToBundleSubsPage("true");

        dispatch(
            setBundleSubscriptionPopupState({
                showBundleSubscriptionPopup: false,
                loadingBundleSubscription: true,
            }),
        );

        setTimeout(
            () =>
                dispatch(
                    setBundleSubscriptionLoadingState({
                        loadingBundleSubscription: false,
                    }),
                ),
            3000,
        );

        logFirebaseEvent(EventNames.BUNDLE_SUBSCRIPTION_REDIRECT, {
            action: EventActions.BUNDLE_SUBSCRIPTION_REDIRECT,
        });
        openSSOLink(bundleSubsSsoLink, true);
    };
    return (
        <React.Fragment>
            {!isZoomAllowed ? (
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, viewport-fit=cover"
                    />
                </Helmet>
            ) : (
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, user-scalable=1, viewport-fit=cover"
                    />
                </Helmet>
            )}

            <CommonActions />

            <AppConfimationDialog
                open={isAuthenticated && show}
                onConfirm={yesClick}
                onClose={noClick}
                popupMainText={messaging.notification.permission.prompt}
                confirmText={messaging.notification.permission.promptYes}
                cancelButtonText={messaging.notification.permission.promptNo}
                showConfirmFirst={true}
            />

            {isAuthenticated &&
                !showRedirectionDialog &&
                !loadingConsent &&
                getIsLtdConsentFormOpened() !== "true" &&
                showPurchaseBundlePopup && (
                    <RedirectionDialog
                        open={showPurchaseBundlePopup}
                        onClose={handleClosePurchaseBundlePopup}
                        dialogMessage={messaging.purchaseBundle.message}
                    />
                )}

            {isAuthenticated &&
                !showRedirectionDialog &&
                !loadingConsent &&
                getIsLtdConsentFormOpened() !== "true" &&
                showBundleOptInPopup && (
                    <RedirectionDialog
                        open={showBundleOptInPopup}
                        onClose={handleCloseBundleOptInPopup}
                        dialogMessage={messaging.bundleOptIn.popup.message}
                    />
                )}

            {isAuthenticated &&
                !showRedirectionDialog &&
                !loadingConsent &&
                getIsLtdConsentFormOpened() !== "true" &&
                showBundleSubscriptionPopup && (
                    <RedirectionDialog
                        open={showBundleSubscriptionPopup}
                        onClose={handleCloseBundleSubsPopup}
                        dialogMessage={
                            messaging.bundleSubscription.popup.message
                        }
                    />
                )}

            {isAuthenticated && showRedirectionDialog && (
                <RedirectionDialog
                    open={showRedirectionDialog}
                    onClose={handleClose}
                    dialogMessage={messaging.consentForm.ssoRedirection}
                />
            )}

            {(loadingConsent ||
                loadingBundleOptIn ||
                loadingBundleSubscription ||
                loadingPurchaseBundle) && (
                <AppBackdropProgress
                    open={loadingConsent}
                    backdropText={messaging?.loader?.loadingSession}
                />
            )}

            <Router>
                {deviceAllowed ? (
                    <ScrollToTop>
                        <MiniPlayer />
                        <Routes>
                            <Route
                                path={routeProvider.react.login()}
                                element={
                                    isAuthenticated ? (
                                        <Navigate
                                            to={routeProvider.react.home()}
                                            replace
                                        />
                                    ) : (
                                        <Login />
                                    )
                                }
                            />
                            <Route
                                path={routeProvider.react.userHistory()}
                                element={<UserHistory />}
                            />
                            <Route
                                path={routeProvider.react.audios().listing()}
                                element={
                                    <PrivateRoute
                                        element={<AudiosContentListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.audios().index()}
                                element={<PrivateRoute element={<Audios />} />}
                            />
                            <Route
                                path={routeProvider.react.audios().detail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <AudioContentDetail
                                                key={window.location.pathname}
                                            />
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.videos().index()}
                                element={<PrivateRoute element={<Videos />} />}
                            />
                            <Route
                                path={routeProvider.react.videos().listing()}
                                element={
                                    <PrivateRoute
                                        element={<VideosContentListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.videos().detail()}
                                element={
                                    <PrivateRoute
                                        element={<VideoContentDetail />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.gifts().index()}
                                element={<PrivateRoute element={<Gifts />} />}
                            />
                            <Route
                                path={routeProvider.react.gifts().listing()}
                                element={
                                    <PrivateRoute
                                        element={<GiftsContentListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.gifts().detail()}
                                element={
                                    <PrivateRoute
                                        element={<PurchaseGiftDetail />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .gifts()
                                    .giftAudioDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <ReceivedGiftsDetail
                                                key={window.location.pathname}
                                            />
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.bundle().audios()}
                                element={
                                    <PrivateRoute element={<BundleDetail />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.bundle().play()}
                                element={
                                    <PrivateRoute element={<BundlePlayer />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .gifts()
                                    .giftsGivenListing()}
                                element={
                                    <PrivateRoute
                                        element={<GiftsGivenListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .gifts()
                                    .giftsGivenContentListing()}
                                element={
                                    <PrivateRoute
                                        element={<GiftsGivenContentListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.home()}
                                element={<PrivateRoute element={<Home />} />}
                            />
                            <Route
                                path={routeProvider.react.courses().index()}
                                element={<PrivateRoute element={<Courses />} />}
                            />
                            <Route
                                path={routeProvider.react.courses().detail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <CourseDetail />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .gifts()
                                    .courseDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <CourseDetail />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.more().index()}
                                element={
                                    <PrivateRoute element={<MoreMenu />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .courses()
                                    .mediaStepDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <CourseStep />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .gifts()
                                    .courseMediaStepDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <CourseStep />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.events().index()}
                                element={<PrivateRoute element={<Events />} />}
                            />
                            <Route
                                path={routeProvider.react.events().detail()}
                                element={
                                    <PrivateRoute
                                        element={<EventContentDetail />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.fycStatus().index()}
                                element={
                                    <PrivateRoute element={<FycStatus />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.webcast().index()}
                                element={<PrivateRoute element={<Webcast />} />}
                            />
                            <Route
                                path={routeProvider.react.webcast().detail()}
                                element={
                                    <PrivateRoute element={<WebcastDetail />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.webcast().stream()}
                                element={
                                    <PrivateRoute element={<WebcastStream />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.appInfo().index()}
                                element={<PrivateRoute element={<AppInfo />} />}
                            />
                            <Route
                                path={routeProvider.react.playlist().index()}
                                element={
                                    <PrivateRoute
                                        element={<PlaylistListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.playlist().detail()}
                                element={
                                    <PrivateRoute
                                        element={<PlaylistDetail />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.playlist().play()}
                                element={
                                    <PrivateRoute
                                        element={<PlaylistPlayer />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.attachedSku()}
                                element={
                                    <PrivateRoute element={<AttachedSku />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.feedback().index()}
                                element={
                                    <PrivateRoute element={<Feedback />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.favorites().index()}
                                element={
                                    <PrivateRoute element={<Favorites />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteAudiosListing()}
                                element={
                                    <PrivateRoute
                                        element={<FavoritesAudiosListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteVideosListing()}
                                element={
                                    <PrivateRoute
                                        element={<FavoritesVideosListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteDocumentsListing()}
                                element={
                                    <PrivateRoute
                                        element={<FavoritesDocumentsListing />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteVideosDetail()}
                                element={
                                    <PrivateRoute
                                        element={<VideoContentDetail />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteAudiosDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <AudioContentDetail
                                                key={window.location.pathname}
                                            />
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteBundleAudios()}
                                element={
                                    <PrivateRoute element={<BundleDetail />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .favorites()
                                    .favoriteBundlePlay()}
                                element={
                                    <PrivateRoute element={<BundlePlayer />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.gifts().sync()}
                                element={<PrivateRoute element={<SyncDYS />} />}
                            />
                            <Route
                                path={routeProvider.react.documents().index()}
                                element={
                                    <PrivateRoute element={<Documents />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.documents().detail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <DocumentDetail />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .downloadingQueue()
                                    .index()}
                                element={
                                    <PrivateRoute
                                        element={<DownloadingQueue />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .recommendations()
                                    .index()}
                                element={
                                    <PrivateRoute
                                        element={<Recommendations />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react.appSettings().index()}
                                element={
                                    <PrivateRoute element={<Appsettings />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .giftDashboard()
                                    .index()}
                                element={
                                    <PrivateRoute element={<GiftDashboard />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .audioDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <AudioContentDetail
                                                key={window.location.pathname}
                                            />
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .videoDetail()}
                                element={
                                    <PrivateRoute
                                        element={<VideoContentDetail />}
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .bundleDetail()}
                                element={
                                    <PrivateRoute element={<BundleDetail />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .bundlePlay()}
                                element={
                                    <PrivateRoute element={<BundlePlayer />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .courseDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <CourseDetail />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .courseMediaStepDetail()}
                                element={
                                    <PrivateRoute
                                        element={
                                            <LazyRoute>
                                                <CourseStep />
                                            </LazyRoute>
                                        }
                                    />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .mixedContent()
                                    .index()}
                                element={
                                    <PrivateRoute element={<MixedContent />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.consentForm().index()}
                                element={
                                    <PrivateRoute element={<ConsentForm />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.checklist().index()}
                                element={
                                    <PrivateRoute element={<Checklist />} />
                                }
                            />
                            <Route
                                path={routeProvider.react
                                    .externalSso()
                                    .index(":resourceKey")}
                                element={
                                    <PrivateRoute element={<ExternalSSO />} />
                                }
                            />
                            <Route
                                path={routeProvider.react.sso().index()}
                                element={<SSO />}
                            />
                            <Route
                                path="*"
                                element={
                                    <Navigate
                                        to={routeProvider.react.login()}
                                        replace
                                    />
                                }
                            />
                        </Routes>
                    </ScrollToTop>
                ) : (
                    <Routes>
                        <Route
                            path={routeProvider.react.root()}
                            element={
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Typography variant="h5">
                                        Not Available
                                    </Typography>
                                </Box>
                            }
                        />
                    </Routes>
                )}
            </Router>
        </React.Fragment>
    );
};
